import { Component, ChangeDetectionStrategy,  ViewChild,  TemplateRef, OnInit} from '@angular/core';
import {  startOfDay,  endOfDay,  subDays,  addDays,  endOfMonth,  isSameDay,  isSameMonth,  addHours} from 'date-fns';
import { Subject } from 'rxjs';
import {CalendarDateFormatter, CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView} from 'angular-calendar';
import {language} from '../../../language/vn';
import {CalendarService} from '../../../service/calendar/service-calendar';

import {BsModalService} from 'ngx-bootstrap/modal';

import {EditLichComponent} from './edit.component';
import {CalendarDepartService} from '../../../service/calendar/service-calendardepart';
import {Sessioncommand} from '../../../global/sessioncommand';
import {DatePipe} from '@angular/common';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {ToastrService} from 'ngx-toastr';
import {FileLichDonViComponent} from './file.component';
import {CustomDateFormatter} from '../../../service/calendar/custom-calendar-format';

import {Week} from '../../../models/calendar/week';
import {CalendarDepart} from '../../../models/calendar/calendardepart';
import {WeekService} from '../../../service/calendar/service-week';
import {CalendarDepartWeek} from '../../../models/calendar/calendardepartweek';
import {CommandUtil} from '../../../global/commandutil';
import {environment} from '../../../../environments/environment';
import {FormatService} from '../../../service/format/service-format';
import {ShareLichDonViComponent} from './share.component';
import {NavItemService} from '../../../service/staff/service-navitem';
import {CalendarRead} from '../../../models/calendar/calendarread';
import {CalendarDepartReadService} from '../../../service/calendar/service-calendardepartread';
import {CalendarDepartRead} from '../../../models/calendar/calendardepartread';
import {CommentLichCongTacComponent} from '../lichcongtac/comment.component';
import {CommentLichDonViComponent} from './comment.component';
import {LichSuLichCongTacComponent} from '../lichcongtac/lichsu.component';
import {TongHopLichCongTacComponent} from '../lichcongtac/tonghop.component';
import {LichSuLichDonViComponent} from './lichsu.component';
import {TongHopLichDonViComponent} from './tonghop.component';
import {GroupOTherComponent} from '../groupother/groupother.component';
import {GroupInnerComponent} from '../groupother/groupinner.component';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  selector: 'app-views-info-lichdonvi',
  templateUrl: './lichdonvi.component.html',
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter
    }]
})
export class LichDonViComponent implements OnInit {
  public language= language;
  public currentMonth: number = new Date().getMonth() + 1;
  public currentYear: number = new Date().getFullYear();
  public locale: string = 'vi';
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  events: CalendarEvent[] = [];


  public yearCurrent: number = 0;
  public weekCurrent: number = 1;
  public calendarWeeks: CalendarDepartWeek[] = [];
  public calendarDeparts: CalendarDepart[] = [];
  public weeks: Week[] = [];
  public years: number[] = [];
  public totalWeek: number = 0;
  public srFromDate: Date = new Date();
  public srToDate: Date= new Date();
  public strF: string= '';
  public strT: string= '';
  public srTuKhoa: string='';
  public permissionCNLichDV: boolean = false;
  public permissionRead: boolean = false;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public donViTao: number = Sessioncommand.maDonVi;
  public urlExportLichDonVi: string = environment.exportLichDonVi;
  public urlExportDSLichDonVi: string = environment.exportDSLichDonVi;
  @ViewChild("selectGroup")
  public selectGroup: GroupInnerComponent;
  @ViewChild("selectGroupList")
  public selectGroupList: GroupInnerComponent;
  ngOnInit(): void {
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0023,0014", true).subscribe(
      x => { this.permissionCNLichDV = x>0? true: false;
        this.loadEvent();
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0015", true).subscribe(
      x => { this.permissionRead = x>0? true: false;

      }
    );
       this.yearCurrent = this.viewDate.getFullYear() ;
    for(let i= 2005 ;i <= this.viewDate.getFullYear() + environment.yearNext; i++)
      this.years.push(i);
    this.weekService.getAll(this.viewDate.getFullYear()).subscribe(data =>
    {
      this.weeks = data;
      let t: number = data.findIndex( x => x.status === true);
      this.totalWeek = data.length;
      this.weekCurrent = data[t !== -1 ? t : 0].id;
      this.loadDataWeek();
    });
    this.formatService.getFirstLastCurrentByMonth().subscribe(
      data => {
        this.srFromDate= new Date(data.firstDate);
        this.srToDate= new Date(data.lastDate);
        this.search();
      });
  }
  public actions: CalendarEventAction[] = [
    {
      label: '<i class="icon-pencil"></i>',
      a11yLabel: language.update,
      onClick: ({ event }: { event: CalendarEvent }): void => {
      this.edit(Number(event.id));
      },
    },
    {
      label: '<i class="icon-trash"></i>',
      a11yLabel: language.delete,
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.showConfirmationModal(Number(event.id));
      },
    },
    {
      label: '<i class="icon-paper-clip"></i>',
      a11yLabel: language.filedinhkem,
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.download(Number(event.id));
      }
    }
  ];
  public yKien(): void {
    const modalEdit = this.bsModalService.show(CommentLichDonViComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<CommentLichDonViComponent>modalEdit.content).edit(
      this.weekCurrent, this.yearCurrent
    );
    (<CommentLichDonViComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public lichSu(id: number): void {
    const modalEdit = this.bsModalService.show(LichSuLichDonViComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<LichSuLichDonViComponent>modalEdit.content).show(
      id
    );
    (<LichSuLichDonViComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public yKienTongHop(): void {
    const modalEdit = this.bsModalService.show(TongHopLichDonViComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<TongHopLichDonViComponent>modalEdit.content).edit(
      this.weekCurrent, this.yearCurrent
    );
    (<TongHopLichDonViComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public loadDataWeek()
  {
    let donViList: String = "-1";
    if(this.selectGroup.selectTree.value !== null && this.selectGroup.selectTree.value.length>0 ) {
      donViList = this.selectGroup.selectTree.value.join();
    }
    this.calendarDepartService.getDataByWeekYear(this.weekCurrent, this.yearCurrent, donViList,
      -1, -1, Sessioncommand.maDonVi).subscribe(data => {
      this.calendarWeeks = data;
      if(data.filter(k => k.calendars.length > 0).length > 0)
      {
        let calendarDepartRead: CalendarDepartRead = new CalendarDepartRead();
        calendarDepartRead.staffID = Sessioncommand.staffId;
        calendarDepartRead.weekID = this.weekCurrent;
        calendarDepartRead.yearID = this.yearCurrent;
        calendarDepartRead.donViId = Sessioncommand.maDonVi;
        this.calendarDepartReadService.add(calendarDepartRead).subscribe( {
          next: (datax) => {
            console.log(datax.id);
          },
          error: error => {
            console.log(error);
          }
        }) ;
      }
    });
  }
  public loadWeek(year : number)
  {
    this.weekService.getAll(year).subscribe(data => this.weeks = data);
  }
  public nextData()
  {
    this.weekCurrent += 1;
    if(this.weekCurrent >= this.totalWeek + 1)
    {
      this.yearCurrent += 1;
      this.weekCurrent = 1;
      this.weekService.getAll(this.yearCurrent).subscribe(data =>
      { this.weeks = data;
        this.totalWeek = data.length;
        this.loadDataWeek();
      });
    }else
      this.loadDataWeek();

  }
  public beforeData()
  {
    this.weekCurrent = this.weekCurrent - 1;
    if(this.weekCurrent == 0)
    {
      this.yearCurrent = this.yearCurrent -1;
      this.weekService.getAll(this.yearCurrent).subscribe(data =>
      { this.weeks = data;
        this.totalWeek = data.length;
        this.weekCurrent = this.totalWeek;
        this.loadDataWeek();
      });
    }else
      this.loadDataWeek();
  }

  public loadEvent()
  {
    this.currentYear=this.viewDate.getFullYear();
    this.currentMonth= this.viewDate.getMonth()+1;
    this.events=[];
    this.calendarDepartService.findByMonth(this.currentMonth, this.currentYear, Sessioncommand.maDonVi,
      -1, -1).subscribe( x =>{
        for(let i=0; i<x.length;i++)
        {
          let colorsItem: any = {
            color: {
              primary: x[i].bgColor,
              secondary: x[i].bgColor,
            }
          };
          let check : boolean = (this.permissionCNLichDV && x[i].donViTao!=null && x[i].donViTao.id === this.donViTao);
          this.events.push(
            {
              id: x[i].id,
              start: new Date(this.datePipe.transform(x[i].tuNgay,'yyyy-MM-dd') + ' ' + (x[i].tuGio !== null ? x[i].tuGio : '00:00')),
              end: new Date(this.datePipe.transform(x[i].denNgay,'yyyy-MM-dd')  + ' ' +  (x[i].denGio !== null ? x[i].denGio : '23:59')),
              title: x[i].noiDung,
              color: colorsItem.color,
              actions: check=== true? this.actions: null,
              resizable: {
                beforeStart: true,
                afterEnd: true,
              },
              draggable: true,
            }
          );
        }
        this.refresh.next();
    });

  }
  public refresh: Subject<any> = new Subject();
  public activeDayIsOpen: boolean = true;

  constructor(
    public calendarDepartService: CalendarDepartService,
    public bsModalService: BsModalService,
    public datePipe: DatePipe,
    public toastr: ToastrService,
    public weekService: WeekService,
    public commandUtil: CommandUtil,
    public formatService: FormatService,
    public navItemService: NavItemService,
    public calendarDepartReadService: CalendarDepartReadService,
    public sanitizer: DomSanitizer
  ) {}
  public edit(id: number): void {
  if(this.permissionCNLichDV === true) {
    const modalEdit = this.bsModalService.show(EditLichComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<EditLichComponent>modalEdit.content).edit(
      id
    );
    (<EditLichComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.loadEvent();
        this.loadDataWeek();
        this.search();
        Sessioncommand.notification = false;

      }
    });
  }else
  {
    this.toastr.error(language.message_not_permission, language.message);
  }

  }
  public share(): void {
    if(this.permissionCNLichDV || this.permissionRead) {
      const modalEdit = this.bsModalService.show(ShareLichDonViComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<ShareLichDonViComponent>modalEdit.content).edit(

      );
      (<ShareLichDonViComponent>modalEdit.content).onClose.subscribe(result => {

      });
    }
  }


  public download(id: number): void {
  if(this.permissionCNLichDV || this.permissionRead) {
    const modalEdit = this.bsModalService.show(FileLichDonViComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<FileLichDonViComponent>modalEdit.content).edit(
      id
    );
    (<FileLichDonViComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  }
  public showConfirmationModal(id: number): void {
   if(this.permissionCNLichDV === true) {
     const modal = this.bsModalService.show(ConfirmDialogComponent);
     (<ConfirmDialogComponent>modal.content).showConfirmationModal(
       language.message,
       language.confirm_delete_question,
       language.yes,
       language.no
     );
     (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
       if (result === true) {
         this.deleteItem(id);
       }
     });
   }else
   {
     this.toastr.error(language.message_not_permission, language.message);
   }
  }
  deleteItem(id: number)
  {
    this.calendarDepartService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.loadEvent();
        this.loadDataWeek();
        this.search();
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  search()
  {
    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    let donViList: String = "-1";
    if(this.selectGroupList.selectTree.value !== null && this.selectGroupList.selectTree.value.length>0 ) {
      donViList = this.selectGroupList.selectTree.value.join();
    }

    this.calendarDepartService.findAllBySearchPaging(this.srTuKhoa, this.strF, this.strT, donViList,
      -1, -1, Sessioncommand.maDonVi, this.currentPage, this.maxSize).subscribe(data => {
      this.calendarDeparts = data;
    });
    this.calendarDepartService.getCountBySearch(this.srTuKhoa, this.strF, this.strT, donViList,
      -1, -1, Sessioncommand.maDonVi).subscribe(resultCount => {
      this.totalItems = resultCount;
    });
  }
  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {

    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }
  eventTimesChanged({
                      event,
                      newStart,
                      newEnd,
                    }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });

  }
  setView(view: CalendarView) {
    this.view = view;
  }
  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }
}
